var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{staticClass:"font-weight-bold mt-6 px-8",class:_vm.replacement_comment && 'mb-0'},[_vm._v(" Ersättningstrafik ")]),_c('p',{staticClass:"px-8 text-body-2 text--secondary"},[_vm._v(" "+_vm._s(_vm.replacement_comment)+" ")]),_c('TrafficMessageRow',{attrs:{"items":_vm.list}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }